import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'

const BillingTransferFee = ({transferData, fetchMembersData, isLoading, id}) => {
    // const navigate = useNavigate() 
    const [transferForm] = Form.useForm();
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [transferInfo, setTransferInfo] = useState([]);

    const handleDelete = (key) => {
        const newData = [...transferInfo];
        newData.splice(key, 1); 
        setTransferInfo(() => newData)
    };
      
    const addRow = () => {
        const newData = [...transferInfo];
        newData.push({
            trfuse_ors: "",
            trfuse_dates: undefined,
            trfuse_amounts: "",
            trfuse_remarks: "",
            isWritable: true,
        });
        setTransferInfo(newData);
    };

    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setTransferInfo(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else {
            const { value } = e.target

            setTransferInfo(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
            return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = transferInfo?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setTransferInfo(newData);
    };

    const defaultColumns = [
        {
            title: 'OR',
            dataIndex: 'trfuse_ors',
            align: 'center',
            key: 'trfuse_ors',
            render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.trfuse_ors}
                    onChange={(e) => handleTable(e, index, "trfuse_ors")}
                />
            ) : record.trfuse_ors
          ),
        },
        {
            title: 'Date',
            dataIndex: 'trfuse_dates',
            align: 'center',
            key: 'trfuse_dates',
            render: (_, record, index) => (
            record.isWritable ? (
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.trfuse_dates}
                    onChange={(e) => handleTable(e, index, "trfuse_dates", true)}
                />
            ) : record.trfuse_dates?.format('MMMM D, YYYY')
          ),
        },
        {
            title: 'Amount',
            dataIndex: 'trfuse_amounts',
            align: 'center',
            key: 'trfuse_amounts',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.trfuse_amounts}
                    onChange={(e) => handleTable(e, index, "trfuse_amounts")}
                />
            ) : record.trfuse_amounts
          ),
        },
        {
            title: 'Remark',
            dataIndex: 'trfuse_remarks',
            align: 'center',
            key: 'trfuse_remarks',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.trfuse_remarks}
                    onChange={(e) => handleTable(e, index, "trfuse_remarks")}
                />
            ) : record.trfuse_remarks
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                e.stopPropagation();
                },
            }),
        },
    ];

    const handleCreateAdvance = () => {
        transferForm.validateFields().then(values => {
            const newValues = {
                member_id: id,
                id: [],
                trfuse_ors: [],
                trfuse_remarks: [],
                trfuse_amounts: [],
                trfuse_dates: [],
            }

            transferInfo?.forEach(item => {
                newValues.id.push(item.id || "");
                newValues.trfuse_ors.push(item.trfuse_ors || "");
                newValues.trfuse_remarks.push(item.trfuse_remarks || "");
                newValues.trfuse_amounts.push(item.trfuse_amounts || "");
                newValues.trfuse_dates?.push(item.trfuse_dates ? item.trfuse_dates.format("YYYY-MM-DD") : "");
            });

            callPost(
                "members/update_transfer_fee", 
                newValues,
                false,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed ', errorInfo);
        });
    };

    const validateArray = (array) => {
        return array.every((item) => {
            return item.trfuse_ors !== "" || item.trfuse_dates !== undefined || item.trfuse_amounts !== "" || item.trfuse_remarks !== "";
        });
    };  

    useEffect(() => {
        if(transferData){
            const admission_data = transferData?.map((data) => ({
                id: data.id,
                member_id: data.member_id,
                trfuse_ors: data.or,
                trfuse_dates: data.date ? dayjs(data.date) : undefined,
                trfuse_amounts: data.amount,
                trfuse_remarks: data.remark,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setTransferInfo(admission_data)
        }
    }, [transferData])
 
    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={transferInfo}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 800 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAdvance}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(transferInfo)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default BillingTransferFee
